<template>
  <div class="div-TimeLine">
    <el-button @click="preplanDeduction">预案推演</el-button>
    <el-button @click="confirm">确定</el-button>
    <canvas @mousewheel.stop.prevent="onMouseweel" class="canvas" ref="canvas"></canvas>
  </div>
</template>

<script>
import { ZOOM } from "./constant";
import TimeLine from "./TimeLine.js";
import MilitarySimulation from "../PlanEditor/Actions/militarySimulation.js";
let TimeLineHelp = null;
export default {
  props: ["timeSegments"],
  data() {
    return {
      timeSegmentsData: [],
    };
  },

  mounted() {
    this.$nextTick(() => {
      let opt = {
        canvas: this.$refs.canvas,
        width: window.innerWidth,
        height: 800,
        tableData: this.timeSegments,
        timeSegments: this.timeSegments,
      };

      console.log(this.timeSegments);
      TimeLineHelp = new TimeLine(opt);

      this.$bus.$on("planStart", (diff) => {
        TimeLineHelp.setTime(diff);
        // clearInterval(this.timer);
        // this.timer = setInterval(() => {
        //   console.log(wf.getTimestampDiff());
        //   let time = wf.getTimestampDiff();
        //   TimeLineHelp.setTime(time);
        //   if (wf.finished) {
        //     clearInterval(this.timer);
        //   }
        // }, 400);
      });
    });
  },

  methods: {
    /**
     * 获取时序数据
     */
    confirm() {
      let tableData = TimeLine.change2TableData(this.timeSegmentsData);
      console.log(tableData);
      this.$bus.$emit("updateTableData", tableData);
    },
    /**
     * 开始推演
     */
    preplanDeduction() {
      let res = TimeLineHelp.getTableData();
      this.timeSegmentsData = res.slice();
      console.log(res);

      let startTime = TimeLineHelp.getStartTime();
      let endTime = TimeLineHelp.getEndTime();
      MilitarySimulation.startTimeLine(res, startTime, endTime, (diff) => {
        TimeLineHelp.setTime(diff);
      });
    },
    onMouseweel(event) {
      let e = window.event || event;
      let delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
      //缩小
      if (delta < 0) {
        if (TimeLineHelp.currentZoomIndex + 1 < ZOOM.length - 1) {
          TimeLineHelp.currentZoomIndex++;
        }
      } else if (delta > 0) {
        // 放大
        if (TimeLineHelp.currentZoomIndex - 1 > 0) {
          TimeLineHelp.currentZoomIndex--;
        }
      }

      TimeLineHelp.setZomm();
    },

    setTime(time) {
      TimeLineHelp.setTime(time);
    },
  },
};
</script>

<style lang="scss" scoped>
.div-TimeLine {
  margin: 20px;
  overflow: auto;
  position: relative;
  height: -webkit-fill-available;
}
</style>
